module.exports = __webpack_public_path__ + "img/EPAPOWER.77d308f.jpg";